<template>
  <div class="sidebar-header">
    <div class="profile-info">
      <figure class="user-cover-image"></figure>
      <div class="user-info">
          <img :src='(globals.compaynLogo) ? globals.compaynLogo : "../../../../assets/img/logo-dark.jpg"'> <!-- VRBA ovdje ide logo od tvrtke -->
          <h6 class="">{{globals.nameAndSurname}}</h6> <!-- VRBA ovdje ide ime i prezime doktora -->
          <p class="">{{globals.title}}</p> <!-- VRBA ovdje ide titula doktora -->
          <p class="">{{globals.companyName}}</p> <!-- VRBA ovdje ide naziv tvrtke -->
        </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';

export default {
    name: 'sidebar-header',
    computed:
  {
      ...mapGetters([
          'globals',
      ]),
  },
};
</script>
